const signUp = {
  SIGN_UP_TO_JOIN_US: "注册并加入我们",
  USER_PROFILE: "用户资料",
  LOGIN_CREDENTIALS: "登录凭证",
  CONFIRM_PASSWORD: "确认密码",
  PLEASE_ENTER_YOUR_USERNAME: "请输入用户名",
  PLEASE_ENTER_YOUR_PASSWORD: "请输入密码",
  PLEASE_CONFIRM_YOUR_PASSWORD: "请确认密码",
  PLEASE_ENTER_YOUR_EMAIL: "请输入邮箱地址",
  PLEASE_ENTER_YOUR_PHONE: "请输入手机号码",
  EG_PROFESSOR_OF_TRADITIONAL_CHINESE_MEDICINE: "例如：中医专业人员",
  PLEASE_BRIEFLY_INTRODUCE_YOURSELF: "请简要介绍自己",
  TRADITIONAL_CHINESE_MEDICINE_IS_A_DISCIPLINE_THAT_UTILIZES_NATURAL_PRINCIPLES_COMBINED_WITH_VARIOUS_PHYSIOLOGICAL_AND_PATHOLOGICAL_CHANGES_IN_THE_BODY:
    "例如：中医学是一门结合自然原理与人体各种生理和病理变化的学科。",
  HERBAL_MEDICINE: "中药治疗",
  SIGN_UP: "注册",
  SIGN_UP_AS_PRACTITIONER: "注册为医师",
};

const navigation = {
  PRACTITIONER: "医师",
  PRACTITIONER_PORTAL: "医师平台",
  HOME: "主页",
  ABOUT_US: "关于我们",
  PARTNERS: "合作伙伴",
  MEMBER_SERVICE: "学会服务",
  CPD_TRAINING: "CPD培训",
  TRAINING_AND_COURSES: "培训与课程",
  EVENT: "学会活动",
  NEWS: "最新动态",
  BECOMING_MEMBER: "成为会员",
  LOGIN_SIGNUP: "登录/注册",
  ONLINE_PAYMENT: "在线支付",
  DOWNLOAD_CENTER: "下载园区",
  AGREE_TO_USE_VAI_CLINIC_TEXT: "登录即表示您同意",
  SIGN_IN: "登录",
  SIGN_OUT: "登出系统",
  USERNAME: "用户名",
  PASSWORD: "密码",
  FORGET_PASSWORD: "忘记密码",
  AND: "和",
  PLEASE_ENTER_YOUR_USERNAME: "请输入您的用户名",
  PLEASE_ENTER_YOUR_PASSWORD: "请输入您的密码",
  CLINIC: "诊所",
  PRACTITIONER_PROFILE: "个人网页定制",
  CONTACT_US: "联系我们",
  GO_BACK: "返回",
  PREVIOUS_FEATURE: "上一个功能",
  NEXT_FEATURE: "下一个功能",
  STILL_HAVE_QUESTIONS: "还有其他问题吗?",
  FAQ_HELP_DESCRIPTION: "我们的团队随时为您提供帮助。",
  FAQ_SUPPORTING_LINE: "快速解答您最关心的问题。",
  ADD_PATIENT: "添加新患者",
  SELECT_CLINIC_TO_WORK: "选择工作诊所",
  SELECT_CLINIC: "选择诊所",
  PRESCRIPTION_MEDICAL_HISTORY: "病历与开方",
};

const prescription = {
  CLEAR_SEARCH: "清空",
  PRESCRIPTION: "病历",
  PATIENT_PRESCRIPTION: "患者病历",
  DOCTOR_PRESCRIPTION: "医师处方",
  NO_PRESCRIPTION_FOUND: "未找到处方",
  NO_PREVIOUS_HISTORY: "未找到历史",
  PRESCRIPTION_NOT_FOUND: "处方未找到",
  "EDIT_NOW_HISTORY_#X": "正在编辑病历 #{{X}}",
  EDITING_NOW: "正在编辑",
  NO_ENGLISH_ENTRY: "无英文记录",
  NO_CHINESE_ENTRY: "无中文记录",
  ENGLISH_CONTENT: "英文内容",
  CHINESE_CONTENT: "中文内容",
  CASE_ID: "病历编号",
  DATE: "日期",
  CREATED_BY: "创建人",
  PAYMENT_STATUS: "支付状态",
  ACTION: "操作",
  NOT_PAID: "未支付",
  PAID: "已支付",
  CARD_ONLINE: "在线支付",
  CARD_OFFLINE: "线下刷卡",
  CASH: "现金",
  FILTER_BY_DATE: "按日期筛选",
  SELECT_DEFAULT_DATE_RANGE: "选择默认日期范围",
  SELECT_CUSTOM_DATE_RANGE: "选择自定义日期范围",
  LAST_ONE_YEAR: "过去一年",
  LAST_ONE_MONTH: "过去一个月",
  LAST_THREE_MONTHS: "过去三个月",
  ROWS_PER_PAGE: "每页行数",
  MORE_INFORMATION: "更多信息",
  AGE: "年龄",
  PRESCRIPTION_FORM: "处方单",
  CREATE_CASE: "创建病历",
  SELECT_OPTIONS: "选择选项",
  CLICK_TO_RECORD: "点击开始录音",
  TRANSLATE_TO_X: "翻译为{{X}}",
  COMPLAINTS_SYMPTOMS: "主诉与症状",
  PAST_DISEASE: "既往病史",
  FAMILY_DISEASE_HISTORY: "家族病史",
  ALLERGY: "过敏史",
  ALLERGEN: "过敏原",
  CURRENT_MEDICINE_TAKEN: "当前用药",
  SIGNS_DIAGNOSIS: "体征与诊断",
  ATTACHMENT: "附件",
  REMARKS: "备注",
  CLICK_DRAG_TO_UPLOAD: "点击或拖拽上传",
  NO_ATTACHMENT_FOUND: "未找到附件",
  TREATMENT_PLAN: "治疗方案",
  PATIENT_ADVICES: "医嘱",
  PROCEED_TO_PAYMENT: "前往付款",
  PROCEED_TO_TREATMENT: "进入治疗",
  MEDICINE: "中药",
  PRESCRIBE_MEDICATION_TO_THE_PATIENT: "为患者开具中药",
  PRESCRIBE_ACUPUNCTURE_TO_THE_PATIENT: "为患者提供针灸治疗",
  PRESCRIBE_MASSAGE_TO_THE_PATIENT: "为患者按摩治疗",
  PRESCRIBE_REMEDIAL_MASSAGE_TO_THE_PATIENT: "为患者提供理疗按摩治疗",
  SELECT: "选择",
  MODALITY: "治疗方式",
  MEDICINE_TREATMENT_NAME: "治疗名称",
  PREVIOUS_STEP: "上一步",
  PATIENT_HERB_HISTORY: "患者中药记录",
  APPLY: "应用",
  HERB: "中药",
  RAW: "生药量 (g)",
  GRAN: "颗粒剂量 (g)",
  TOTAL: "总计",
  FORMULA: "药方",
  CLASSICAL: "药方",
  SINGLE_HERB: "单味中药",
  TYPE: "类型",
  SELECT_HERBS: "选择中药",
  SEARCH_CLASSICAL_FORMULA: "搜索经典方",
  PLEASE_SEARCH_BY_NAME: "请按名称搜索",
  CANCEL_SEARCH: "取消搜索",
  ADD_ALL_HERBS_IN_FORMULA: "添加整方",
  X_HERBS_INCLUDED: "已包含{{X}}味药",
  FILL_IN_THE_DOSAGE: "填写剂量",
  HERBS_ADDED: "已添加的中药",
  PLS_SELECT_HERB_FROM_HISTORY_OR_FORMULA: "请从药方或过往历史添加中药",
  GRAMS_DAILY: "每日剂量",
  DAYS: "天数",
  TOTAL_GRANS: "总剂量",
  DOSAGE_INSTRUCTION: "服药说明",
  DOSAGE: "剂量",
  NO_OF_REPEATS: "重复次数",
  TO_BE_DISPENSED_AFTER: "下次取药时间",
  WEEK: "周",
  RAW_HERBS: "原药材",
  HERBS_EXTRACT: "中药提取物",
  HERBAL_MEDICATION: "中药治疗",
  EXTERNAL: "外用药",
  HERB_BOIL_GUIDE: "煎药指导",
  SECOND_BOIL_REQUIRED: "需要二煎",
  FIRST_BOILS: "首次煎煮",
  NO_CUP_WATER: "加几碗水",
  BOIL_TIME: "煎煮时间",
  NO_CUPS_REMAINS: "煎成几碗",
  MIN_BOIL_TIME: "最小煎煮时间（分钟）",
  PLEASE_ENTER_NUMBER: "请输入数字",
  SELECT_POINT: "选择穴位",
  X_HISTORY: "{{X}}条历史记录",
  POINT: "穴位",
  X_GROUP: "{{X}}分组",
  POINT_GROUPS: "穴位分组",
  ORDER: "顺序",
  SINGLE_POINT: "单一穴位",
  REVIEW_THE_POINTS: "检查所选穴位",
  PLS_SELECT_POINT_FROM_HISTORY_OR_GROUP: "请从历史或穴位分组中添加穴位",
  DROP_HERE: "拖放到此处",
  X_INSTRUCTION: "{{X}}说明",
  DURATION: "持续时间",
  PLS_ENTER_THE_DURATION: "请输入持续时间",
  PRECAUTION: "注意事项",
  PLS_ENTER_THE_PRECAUTION: "请输入注意事项",
  POINTS_ADDED: "穴位已添加",
  PAYMENT: "付款",
  FILL_IN_THE_PAYMENT_DETAILS: "填写付款信息",
  SUBTOTAL: "小计",
  OTHER_FEE: "其他费用",
  DIAGNOSIS_FEE: "诊疗费",
  FEE: "费用",
  TOTAL_AMOUNTS: "总金额",
  ADD_FEE: "添加费用",
  FEE_LABEL: "费用标签",
  PLEASE_ENTER_LABEL: "请输入标签",
  FEE_AMOUNT: "费用金额",
  PLEASE_ENTER_AMOUNT: "请输入金额",
  MEDICAL_REBATE: "医保返还",
  MEDICAL_FUNDS_OF_PATIENT: "是否使用患者医保",
  REBATE_AMOUNT: "返还金额",
  ANY_DISCOUNT: "是否有折扣",
  PENDING_PAYMENT_AMOUNT: "待支付金额",
  PAYMENT_METHOD: "支付方式",
  DISCOUNT_AMOUNT: "折扣金额",
  FINISH_PAYMENT: "完成支付",
  PLEASE_ENTER_YOUR_CARD_DETAILS_BELOW_TO_COMPLETE_YOUR_PURCHASE:
    "请填写下方信用卡信息以完成付款",
  PAYMENT_FAILED_PLEASE_TRY_AGAIN: "支付失败，请重试",
  X_TRIES_LEFT: "剩余{{X}}次尝试",
  TOTAL_AMOUNT_CANNOT_BE_NEGATIVE: "总金额不能为负数",
  PAY_NOW: "立即支付",
  YOUR_PAYMENT_HAS_BEEN_SUCCESSFULLY_PROCESSED: "您的支付已成功处理",
  SYSTEM_REDICTING: "系统正在跳转...",
  SURCHARGE_WILL_BE_INCLUDED: "已包含手续费",
  PROCESSING_PAYMENT: "正在处理支付",
  LAST_MODIFIED_AT: "最后修改时间",
  PAY: "支付",
  NEXT: "下一步",
  PRINT_RECEIPT: "打印收据",
  GENERATING: "生成收据中",
  NO_MEDICAL_HISTORY_FOUND: "未填写病历",
  NO_TREATMENTS_INCLUDED: "未包含治疗方案",
  TREATMENT: "治疗",
  VIEW_X_INSTRUCTION: "查看{{X}}说明",
  X_SURCHARGE_AMOUNT: "{{X}}手续费",
  DISCOUNT: "折扣",
  COLLAPSE_ALL: "全部收起",
  EXPAND_ALL: "全部展开",
  VIEW_DOSAGE_INSTRUCTION: "查看用药说明",
  NO_TREATMENTS_INCLUDED: "未包含治疗方案",
  FINISH: "总结",
  X_OPTIONS: "{{X}}选项",
  FULL_CONTENT_MODE: "全文模式",
  HAS_BEEN_ADDED: " 已添加",
  ALL_HERBS_IN_FORMULA_HAS_ADDED: "药方中的所有中药已添加",
  CLASSICAL_FORMULA: "药方",
  PLS_ENTER_NUMBER: "请输入数字",
  SEARCH_CLASSICAL_FORMULA_BY_NAME: "按名称搜索药方",
  SEARCH_HERB_BY_NAME: "按名称搜索中药",
  REMOVE_TREATMENT: "移除治疗手段",
  ARE_YOU_SURE_TO_REMOVE: "确定要移除吗",
  SECOND_BOILS: "第二次煎煮",
  MIN_BOILING: "煎煮时间（分钟）",
  X_POINTS_INCLUDED: "已包含{{X}}个穴位",
  ADD_ALL_POINTS_IN_FORMULA: "添加分组中的所有穴位",
  SEARCH_POINT_GROUPS_BY_NAME: "按名称搜索穴位分组",
  SEARCH_POINT_BY_NAME: "按名称搜索穴位",
  ALL_POINTS_IN_FORMULA_HAS_ADDED: "分组中的所有穴位已添加",
  THIS_TREATMENT_HAS_NO_PRICE_OR_PRICE_ZERO: "该治疗无定价或价格为零",
  PAYMENT_CHANNEL_EXPIRED_PLS_RELOAD_PAGE: "支付通道已失效，请刷新页面重试",
  ENTER_FEE_AMOUNT: "请输入费用金额",
  NO_TREATMENT_INCLUDED_IN_THIS_PRESCRIPTION: "该处方未包含任何治疗",
  PLEASE_SELECT_TREATMENT_TO_PROCEED: "请选择一种治疗方式以继续",
  ADD_TREATMENT: "添加治疗",
  HAS_REMOVED: "已移除",
  PRESCRIBE_X_TO_THE_PATIENT: "为患者开具{{X}}",
  ATTACHMENT_UPLOADED: "附件已上传",
  REMOVE_ATTACHMENT: "移除附件",
  ARE_YOU_SURE_TO_REMOVE_THIS_FILE: "你确定要移除这个附件吗？",
  ATTACHMENT_REMOVED: "附件已移除",
  DELETE_DAILY_SHARING: "删除每日分享",
  ARE_YOU_SURE_TO_DELETE_THIS_DAILY_SHARING: "你确定要删除这条每日分享吗？",
  LAST_SIX_MONTHS: "过去半年",
  INPUT_TOTAL_COST_HERE: "在此输入治疗费用",
  EDIT_PATIENT_INFO: "编辑患者信息",
  ARE_YOU_SURE_TO_CLEAR_ALL_CONTENT_IN_THIS_FIELD:
    "确定要清除以下填写的所有内容吗？",
  CLEAR_CONFIRM: "清空确认",
  DUPLICATE_MEDICAL_HISTORY: "复制病历",
  ARE_YOU_SURE_TO_DUPLICATE_THIS_MEDICAL_HISTORY:
    "你将要复制所选的这条病历记录",
  YOU_WILL_GET_A_NEW_MEDICAL_HISTORY_WITH_PREFILLED_DATA_FROM_LAST_RECORD:
    "你将会获得一条新的病历记录并会预填上所需病历的完整信息。",
  ARE_YOU_SURE_TO_DELETE_MEDICAL_RECORD: "你将删除这条病历记录",
  PATIENT_HISTORY_COPIED: "患者病历复制成功",
  DELETE_SUCCESS: "删除成功",
  ADD_ASSISTANT_EXAMINATION: "添加辅助检查",
  ADD_NOW: "立即添加",
  RESULT_PREVIEW: "总览",
  AUXILIARY_TEST: "辅助检查",
  TEST_NAME: "检查名称",
  TEST_DATE: "检查日期",
  ATTACHMENTS: "附件",
  SELECT_PHOTO_PDF: "选择照片/PDF",
  EXAMINATION: "检查",
  INSPECTION: "望诊",
  TONGUE_PHOTO: "舌象照片",
  FACIAL_PHOTO: "面部照片",
  INQUIRY: "问诊",
  PULSE: "脉诊",
  LISTEN_SMELL: "闻诊",
  BODY_TEMP: "体温",
  BLOOD_PRESSURE: "血压",
  PULSE_RATE: "脉率",
  BREATH_RATE: "呼吸频率",
  PERSONAL_OTHER: "个人习惯及其他",
  ANY_ALLERGY: "是否有过敏",
  ALLERGY_DRUGS: "药物过敏",
  ALLERGY_TRIGGERS: "过敏诱因",
  STD: "是否有性病史",
  PROMISCUITY: "是否有不洁性行为",
  SMOKING: "是否吸烟",
  ALCOHOL_ABUSE: "是否酗酒",
  ADD_HISTORY: "添加过往病史",
  NO_DISEASES: "从未得过",
  FAMILY_DISEASES: "家族病史",
  SYMPTOMS: "症状",
  NO_SYMPTOMS_ADDED: "未添加症状",
  MAIN_SYMPTOM: "主要症状",
  ONSITE_TIME: "发生时间",
  TIME_UNIT: "时间单位",
  RECURRENCE_TIME: "复发时间",
  EXACERBATION_TIME: "加重时间",
  FREQUENCY_OF_OCCURRENCE: "发生频率",
  FREQUENCY: "频率",
  ADD_MAIN_SYMPTOMS: "添加主要症状",
  PREDISPOSITION: "诱因",
  ASSOCIATED_SYMPTOMS: "伴随症状",
  ARE_YOU_SURE_TO_DELETE_THIS_SYMPTOM: "确定要删除此症状吗？",
  DURATION: "持续时间",
  ADD_ASSISTANT_EXAMINATION: "添加辅助检查",
  OTHERS: "其他",
  PROCEED_TO_DIAGNOSIS: "开始诊断",
  UPDATE_SUCCESS: "更新成功",
  PREVIOUS_TREATMENT: "以往治疗",
  ADD_ASSITANT_EXAMINATION: "添加辅助检查",
  ASSISTANT_EXAMINATION: "辅助检查",
  CLICK_TO_ADD: "点击以搜索并添加",
  CLICK_TO_SELECT: "点击以搜索并选择",
  PREVIOUS_HISTORY: "既往病史",
  ADD_EVALUATION: "添加诊断",
  TCM_ICD_CODE: "中医ICD编码",
  DETERMINATION_TCM: "中医诊断名称",
  SYNDROME: "中医证型名称",
  EVALUATION: "诊断",
  DISCIPLINE_TREATMENT_OPTIONS: "治则治法",
  ARE_YOU_SURE_TO_DELETE_THIS_RECORD: "您确定要删除此记录吗？",
  BPM: "次/分钟",
  SYSTOLIC: "高压",
  DIASTOLIC: "低压",
  ADD_NEW_INSURANCE: "添加新医保",
  PLZ_INPUT_INSURANCE_NO: "请输入医保号",
  PLZ_INPUT_COMPANY_NAME: "请输入医保公司名称",
  RESULT: "检查结果",
};

const search = {
  SEARCH: "搜索",
  SEARCH_PLACEHOLDER: "搜索",
  SEARCH_RESULT: "搜索结果",
  NO_SEARCH_RESULT: "未找到搜索结果",
  SEARCHING: "搜索中",
  SEARCH_PATIENT: "按姓名/电子邮箱/手机号搜索患者",
  SEARCH_FOR_PATIENT_IN_TOP_SEARCH_BAR_OR_NEW_PATIENT_HERE:
    "在下方通过搜索患者姓名查找患者，或点击左侧按钮添加新患者。",
  SEARCH_PATIENT_BY_NAME: "按姓名/电子邮箱/手机号搜索患者",
  NO_PATIENT_FOUND: "未找到患者",
  SEARCHING_PATIENT: "正在搜索患者",
};

const info = {
  DOB: "出生日期",
  DATE_OF_BIRTH: "出生日期",
  SELECT_PATIENT: "选择患者",
  X_PRESCRIPTION_INFO: "{{X}}的处方单",
  VIEW_DETAILS: "查看详情",
  "MEDICAL_HISTORY_#X": "病历 #{{X}}",
  LAST_MODIFIED_BY_X_AT_Y: "最后由 {{X}} 于 {{Y}} 修改",
  NEW_MEDICAL_HISTORY: "新病历",
  NOT_SAVED_YET: "尚未保存",
  SAVE_HISTORY: "保存病历",
  PATIENT_INFO: "患者信息",
  PATIENT_ID: "患者ID",
  GENDER: "性别",
  MALE: "男",
  FEMALE: "女",
  MEDICAL_HISTORY: "病历记录",
  APPOINTMENT: "预约记录",
  NO_HISTORY_FOUND: "未找到历史记录",
  DESCRIPTION: "个人简介",
  COMPLAINTS_SYMPTOMS: "主诉/症状",
  DIAGNOSIS: "诊断",
  TREATMENT: "治疗",
  ENGLISH_CONTENT_GOES_HERE: "在此录入英文内容",
  CN_CONTENT_GOES_HERE: "在此录入中文内容",
  EDITING: "编辑中",
  SIGNS_DIAGNOSIS: "体征和诊断",
  TREATMENT_STRATEGIES: "治疗方案",
  ACUPUNCTURE_POINTS_DURATION_METHODS: "穴位、时间和方法",
  ALLERGY: "艾灸",
  REMEDIAL_MASSAGE: "理疗按摩",
  THERAPEUTICAL_MASSAGE: "按摩",
  GUA_SHA: "刮痧",
  OTHER: "其他",
  REMARKS: "备注",
  TRANSLATE_FROM_X: "从{{X}}",
  TRANSLATE_TO_X: "翻译至{{X}}",
  TRANSLATE: "翻译",
  CHINESE: "中文",
  ENGLISH: "英文",
  TRANSLATION_CONFIRM: "翻译确认",
  TRANSLATED_CONTENT_WILL_BE_APPLIED_OVERWRITE_UR_EXISTING_CONTENT:
    "翻译的内容将覆盖现有内容。",
  TRANSLATE_FROM_X_TO_Y: "从 {{X}} 翻译为 {{Y}}",
  ARE_YOU_SURE_TO_TRANSLATE: "是否确认翻译",
  INFO_FILLED: "信息已保存",
  NO_DATA_FOUND: "无数据",
  FULL_CONTENT_X: "{{X}}完整病历",
  "UPDATE_HISTORY_#X": "更新病历 #{{X}}",
  EDIT_DESCRIPTION: "编辑个人简介",
  EDIT_PATIENT: "编辑患者信息",
  BASIC_INFO: "基本信息",
  FIRST_NAME: "名",
  LAST_NAME: "姓",
  CONTACT_DETAIL: "联系方式",
  RESIDENTIAL_ADDRESS: "家庭地址",
  EMERGENCY_CONTACT_DETAIL: "紧急联系人信息",
  RELATIONSHIP: "与患者关系",
  PATIENT_DISCLOSE: "患者补充信息",
  GUARDIAN_NAME: "监护人姓名",
  GUARDIAN: "监护人",
  GUARDIAN_CONTACT_NUMBER: "监护人联系方式",
  GUARDIAN_MOBILE: "监护人联系方式",
  REFERRED_BY: "推荐人",
  NO_INSURANCE: "无医保信息",
  EMERGENCY_CONTACT_PERSON: "紧急联系人",
  EMERGENCY_CONTACT_NUMBER: "紧急联系电话",
  INSURANCE_INFO: "医保信息",
  MORE_DETAILS: "更多信息",
  INSURANCE_X: "医保 {{X}}",
  COMPANY_NAME: "医保公司名称",
  INSURANCE_NO: "保单号",
  EXPIRY_DATE: "到期日期",
  ADD_INSURANCE: "添加医保信息",
  CANCEL: "取消",
  CONFIRM: "确认",
  SELECT_TEMPLATE: "选择网页模板",
  ADD_TEMPLATE: "添加模板",
  EDIT_TEMPLATE: "编辑模式",
  PUBLISH_WEBSITE: "发布网站",
  VIEW_PUBLISHED_WEB: "预览已发布网站",
  TEMPLATE: "网页模板",
  INSURANCE: "医保",
  EXPIRED_IN: "到期日期",
  EXIT_EDIT: "退出编辑",
  X_VERSION: "{{X}}版本",
  MAKE_APPOINTMENT: "预约医生",
  AI_TRANSLATE: "AI翻译",
  EDIT_TITLE: "编辑标题",
  EDIT_NAME: "编辑名称",
  EDIT_INTRODUCTION: "编辑专业描述",
  ADD_SKILL: "添加专长",
  SKILL: "专长描述",
  AI_ENQUIRY: "AI查询",
  EDIT_AVATAR: "编辑头像",
  ADD_AVATAR: "添加头像",
  EDIT_CLINIC: "编辑诊所",
  MY_STRENGTHS: "我的优势",
  STANDARD_TREATMENT: "诊疗特色",
  ACADEMIC: "学术成就",
  PATIENT_REVIEW: "患者评价",
  CLINIC_INFO: "诊所信息",
  EDIT_STRENGTHS: "编辑我的优势信息",
  EDIT_TREATMENT: "编辑治疗信息",
  DR_X_ARTICLE: " {{X}}的文章",
  COURSES: "课程",
  ARTICLES: "文章",
  EDIT_COURSE: "编辑课程",
  UPLOAD_REVIEW_BG: "上传评论背景图",
  EDIT_REVIEW: "编辑患者评论",
  PATIENT: "患者",
  TITLE: "标题",
  SAVE_SUCCESS: "保存成功",
  CLINIC_NAME: "诊所名称",
  PIN_TO_DISPLAY: "置顶显示",
  DELETE: "删除",
  SUBURB: "区",
  POSTCODE: "邮政编码",
  STATE: "州",
  ADD: "添加",
  MOVE_DOWN: "下移",
  MOVE_UP: "上移",
  SPECIALITY: "专长",
  PUBLISHED: "已发布",
  HIDDEN: "隐藏",
  READ: "阅读",
  ADD_ARTICLE: "添加文章",
  SAVE: "保存",
  PUBLISH: "发布",
  RE_UPLOAD_BG: "重新上传背景",
  PATIENT_NAME: "患者姓名",
  PATIENT_DESCRIPTION: "患者描述",
  REVIEW: "评论",
  REUPLOAD_PROFILE_IMAGE: "重新上传头像",
  COURSE: "课程",
  COURSE_TITLE: "课程名称",
  START_DATE: "开始日期",
  START_TIME: "开始时间",
  DURATION: "持续时间",
  COURSE_TYPE: "课程类型",
  OFFLINE_COURSE: "线下课程",
  ONLINE_COURSE: "在线课程",
  MEETING_URL: "课程网址",
  LOCATION: "地点",
  STRENGTH: "优势方面",
  EXIT_PREVIEW: "退出预览",
  MY_PROFILE: "我的档案",
  PURE_HARMONY: "简洁专业模板",
  HERB_ESSENCE: "清新精致模版",
  IM_WORKED_AT: "我已位于",
  START_WORKING: "开始工作",
  TOOLBAR: "工具栏",
  COLLAPSE_TOOLBAR: "收起工具栏",
  EDIT_URL: "编辑网址",
  SLUG: "URL链接",
  EDIT_SLUG: "编辑个人网址",
  PUBLISH_CONFIRM: "发布确认",
  UNPUBLISH_CONFIRM: "取消发布确认",
  ARE_YOU_SURE_TO_X_WEBSITE: "您确定要{{X}}此网页吗？",
  WEBSITE_WILL_BE_PUBLISHED_AND_VISIBLE_TO_PUBLIC_VIA_BELOW_LINK:
    "您的网页将被发布，并允许公众通过以下链接访问",
  WEBSITE_WILL_BE_UNPUBLISHED_AND_HIDDEN_FROM_PUBLIC:
    "您的网页将被取消发布并对公众隐藏",
  U_CAN_STILL_PUBLISH_THE_WSBSITE_LATE_IF_U_WISH:
    "您仍然可以在之后重新发布网页",
  PUBLISH_S: "发布",
  UNPUBLISH_S: "取消发布",
  UNPUBLISH_WEBSITE: "取消发布",
  UNPUBLISHED: "未发布",
  SWITCH_YOUR_TEMPLATE_PUBLISHED: "选择您的新页面模板并发布。",
  CLOSE_EDITOR: "关闭编辑",
  CLOSE: "关闭",
  REMOVE_SUCCESS: "删除成功",
  VIEW_ALL_X_CLINICS: "查看所有 {{X}} 个诊所",
  CONTINUE: "确定",
  ONLY_WORKING_WEEKDAY: "仅在工作日工作",
  WORKING_TIME: "工作时间",
  WORKING_IN_WHOLE_WEEK: "整周工作",
  MONDAY: "周一",
  TUESDAY: "周二",
  WEDNESDAY: "周三",
  THURSDAY: "周四",
  FRIDAY: "周五",
  SATURDAY: "周六",
  SUNDAY: "周日",
  WORKING_TODAY: "设定为工作日",
  END_TIME: "结束时间",
  APPLY_WORKING_TIME_TO_ALL_DAYS: "应用当前工作时间至所有工作日",
  ONLY_WORK_IN_WEEKDAYS: "仅工作日工作",
  WORK_IN_WHOLE_WEEK: "全周工作",
  CURRENT_WORKING_TIME_APPLIED_TO_ALL_DAYS: "当前工作时间已应用于所有工作日",
  DR_X_COURSE: "{{X}}的课程",
  DELETE_ARTICLE: "删除文章",
  ARE_YOU_SURE_TO_DELETE_ARTICLE: "您确定要删除这篇文章吗?",
  THIS_ACTION_CANNOT_BE_UNDONE: "此操作不可撤销",
  SAVE_ARTICLE: "保存文章",
  SAVE_ARTICLE_AND_PUBLISH: "保存文章并发布",
  PUBISH_ARTICLE: "发布文章",
  UNPUBLISH_ARTICLE: "取消发布文章",
  PUBLISH_ARTICLE: "发布文章",
  ARE_YOU_SURE_TO_X_ARTICLE: "您确定{{X}}吗?",
  VISITORS_WILL_NOT_BE_ABLE_TO_VIEW_THIS_ARTICLE: "访客将无法查看这篇文章",
  VISITORS_WILL_BE_ABLE_TO_VIEW_THIS_ARTICLE: "访客可以查看这篇文章",
  UNPUBLISH: "取消发布",
  REMOVE_BG_IMAGE: "移除背景图",
  ARE_YOU_SURE_TO_REMOVE_BG_IMAGE: "您确定要移除背景图片吗？",
  BG_UPLOAD: "上传背景图",
  DEFAULT_BG_WILL_BE_APPLIED: "默认背景图",
  U_ARE_PREPARED_TO_TRANSLATE_UR_WEBSITE_CONTENT: "您已准备好翻译您的网站内容",
  WARNING: "警告",
  IF_YOU_HAVE_INPUTTED_ANY_TEXT_INTO_THE_LANGUAGE_YOU_SELECTED_WILL_BE_OVERWRITTEN:
    "如果您在所选语言中已填入了任何文本信息，这些文本将被覆盖",
  I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_TRANSLATE_USING_AI:
    "我理解该操作并同意使用AI进行翻译",
  ALL_7_DAYS: "整周",
  ARTICLE_TITLE: "文章标题",
  NO_WORKING_DAYS: "无工作时间",
  WEBSITE_PUBLISHED: "网页已发布",
  WEBSITE_UNPUBLISHED: "网页已取消发布",
  TEMPLATE_SWITCHED_AND_PUBLISHED: "模板已更新并发布",
  TRANSLATING_X_PLS_BE_PATIENT: "正在翻译您的网页至{{X}}，请稍候",
  SAVING_TRANSLATION: "正在保存翻译",
  TOGGLE_LANGUAGE: "切换语言",
  TRANSLATE_UR_WEBSITE_USING_AI: "通过AI工具翻译您的网页",
  ARTICLE: "文章",
  VIEW_PATIENT_HISTORY: "查看患者历史",
  PRESCRIPTION_INFO: "患者病历信息",
  TRANSLATE_FROM: "原文",
  TRANSLATE_TO: "翻译至",
  SWAP: "互换",
  NO_WORKING_TIME_AVAILABLE: "无可用工作时间",
  MY_COLLEAGUES: "团队介绍",
  DAILY_SHARING: "每日分享",
  EDIT_MY_COLLEAGUES: "编辑团队介绍",
  ADD_NEW_SHARING: "添加每日分享",
  EDIT_DAILY_SHARING: "编辑每日分享",
  ADD_IMAGE: "添加图片",
  COLLEAGUE_DESCRIPTION: "成员详情",
  REUPLOAD: "重新上传",
  COLLEAGUE: "成员",
  PAY_THE_BALANCE: "支付余额",
  PAYMENT_SUCCESSFUL: "支付成功",
  WHETHER_TO_DISPLAY_THIS_SECTION: "是否展示该模块",
  EDIT_VIDEO: "编辑视频",
  ADD_VIDEO: "添加视频",
  VIDEO: "视频",
  COVER_IMAGE: "封面图片",
  VIDEO_TITLE: "视频标题",
  VIDEO_DESC: "视频描述",
  WATCH: "观看",
  DELETE_VIDEO: "删除视频",
  ARE_YOU_SURE_TO_DELETE_THIS_VIDEO: "确定要删除此视频吗？",
  USED_BY_PHONE: "已被手机使用",
  DISCONNECT_YOUR_PHONE_TO_TYPE_IN: "请断开手机连接以输入内容",
  DISCONNECT: "断开连接",
  CONTENT: "内容",
};

const notification = {
  CLINIC_SWITCHED_TO_X: "诊所已切换至{{X}}",
  ONLY_IMAGE_FILES_ALLOWED: "仅允许图像文件",
  HISTORY_SAVED: "已保存病历",
  TRANSLATION_COMPLETED: "翻译完成",
  "UPDATE_HISTORY_#X": "病历 #{{X}}已更新",
  ARTICLE_TITLE_CANNOT_BE_EMPTY: "文章标题不能为空",
  ARTICLE_UPDATED: "文章已更新",
  ARTICLE_CREATED: "文章已创建",
  ARTICLE_PUBLISHED: "文章已发布",
  ARTICLE_UNPUBLISHED: "文章已取消发布",
  ARTICLE_DELETED: "文章已删除",
  PREVIEW_TEMPLATE: "预览网页",
  U_R_IN_PREVIEW_MODE: "您处于预览模式",
  U_R_IN_EDIT_MODE: "您处于编辑模式",
  PROFILE_IMAGE_UPLOADED: "头像已上传",
  SAVE_SUCCESS: "保存成功",
  INCORRECT_USERNAME_OR_PASSWORD: "用户名或密码错误",
  CLINIC_X_SELECTED: "已选择当前工作诊所: {{X}}",
  AUTHENTICATION_EXPIRED: "身份验证已过期！请尝试重新登录",
  MAKE_AN_APPOINTMENT: "预约",
  APPOINTMENT_TIME: "预约时间",
  PHONE: "电话",
  EMAIL: "电子邮箱",
  FIRST_NAME_IS_REQUIRED: "需要填写名",
  LAST_NAME_IS_REQUIRED: "需要填写姓",
  PHONE_IS_REQUIRED: "需要填写电话",
  INVALID_PHONE_NUMBER: "无效的电话号码",
  PLEASE_FIX_ERRORS: "请修正错误",
  BOOKING_CREATED: "预约已创建",
  FIRSTNAMEEN_IS_REQUIRED: "需要填写名（英文）",
  LASTNAMEEN_IS_REQUIRED: "需要填写姓（英文）",
  INVALID_EMAIL: "无效的电子邮箱",
  EMAIL_IS_REQUIRED: "需要填写电子邮箱",
  ADDRESS_IS_REQUIRED: "需要填写地址",
  LESS_DETAILS: "收起详情",
  REMOVE: "移除",
  COMPANY_NAME_IS_REQUIRED: "需要填写保险公司名称",
  INSURANCE_NUMBER_IS_REQUIRED: "需要填写保险单号",
  CONFIGURATION: "设置",
  SELECT_SECTION_U_ARE_GOING_TO_CONFIGURE: "选择您要设置的功能",
  BUSINESS: "工作",
  CONFIGURE_BUSINESS_TIME: "设置营业时间",
  LANGUAGE: "语言",
  CURRENT_LANGUAGE_X: "当前语言是: {{X}}",
  PATIENT_CREATED: "已创建患者信息",
  PATIENT_EDITED: "患者信息已更新",
  CHECK_IN_SUCCESS: "签到成功",
};

const appointment = {
  APPOINTMENT_INFO: "预约信息",
  APPOINTMENT_STATUS: "预约状态",
  CHECKED_IN: "已就诊",
  CHECK_IN: "开始问诊",
  PROCEED_TO_MEDICAL_HISTORY: "添加病历",
  APPOINTMENT_CLINIC: "预约诊所",
  NAME: "姓名",
  U_MIGHT_LOOKING_FOR_PATIENT: "👀 您在找以下患者吗？",
  NO_RELAVANT_PATIENT_IN_CLINIC: " 看起来此患者信息还未录入进系统。",
  PLS_ADD_PATIENT_FIRST: "您想添加此患者到您的诊所吗？",
  SELECT_EXISTING_PATIENT_FROM_CLINIC_TO_CREATE_MEDICAL_HISTORY:
    "从当前诊所中选择患者以创建新病历",
  CREATE_MEDICAL_HISTORY: "新建病历",
  NONE_OF_PATIENT_ABOVE_IS_CORRECT: "以上患者都不符合？",
  PENDING_CHECK_IN: "已预定",
  PENDING_CHECK_IN_WAITING: "在诊所候诊",
  ARE_YOU_SURE_TO_CHECK_IN_THIS_APPOINTMENT_FOR_X:
    "您确定为{{X}}完成预约签到？",
  AFTER_CHECKED_IN_YOU_CAN_PROCEED_MEDICAL_HISTORY_FOR_THIS_PATIENT:
    "预约签到后，您可以为此患者填写病历。",
  LOADING_APPOINTMENT: "加载预约信息",
  TODAY: "今天",
  MASSAGE: "中医按摩",
  ACUPUNCTURE: "针灸",
  CHINESE_MEDICINE: "中医",
  APPROX: "预计时长:",
  APPROXIMATE_DURATION: "预计时长",
  BUSINESS_TIME: "营业时间",
  WORKING_SERVICES: "服务项目",
  WORKING_DAYS: "工作日期",
  WORKING_TIME_PERIOD: "工作时间段",
  RESET: "重置",
  BLOCK_TIME_SLOTS: "选择休息时间段",
  APPLY_BLOCK_TIMES_TO_ALL_DAYS: "应用当前休息时间至所有工作日",
  LOADING_TIME_SLOTS: "加载时间段",
  NO_AVAILABLE_TIME: "无可用时间段",
  RESET_CLINIC: "成功重置诊所！",
  CLINIC_NOT_FOUND: "未找到诊所",
  SAVE_CLINIC_SUCCESS: "营业时间更新成功",
  PLEASE_SELECT_WORKING_SERVICES: "请选择至少一个服务",
  START_TIME_CANNOT_BE_AFTER_END_TIME: "开始时间不能晚于结束时间",
  END_TIME_CANNOT_BE_BEFORE_START_TIME: "结束时间不能早于开始时间",
  SELECTED_WEEKDAY: "选择的工作日",
  MINUTES: "分钟",
  CLEAR_ALL: "清空",
  CLICK_ON_TIMESLOT_THAT_YOU_DONT_WANT_IT_BE_AVAILABLE_FOR_APPOINTMENT:
    "通过点击来屏蔽您不想让患者预约的时间段",
  SELECT_WORKING_DAY: "选择工作日",
  DECREASE_DURATION: "减少时长",
  INCREASE_DURATION: "增加时长",
  CURRENT_BLOCK_TIME_APPLIED_TO_ALL_DAYS: "当前休息时间已应用于所有工作日",
  SAVE_AS_NOT_WORKING: "设定为非工作日",
  SAVE_AS_WORKING: "设定为工作日",
  CONFIRM_CLEAR_BLOCK_TIMES: "您确定要清除休息时间吗？",
  CHANGING_DURATION_WILL_CLEAR_ALL_BLOCK_TIMES:
    "此操作将清除所有休息时间，包括已选择的时间段，并将其设定为可预约时间段，此操作不可撤销。",
  CHANGING_WORKING_TIME_WILL_CLEAR_TODAY_BLOCK_TIMES:
    "此操作将清除当前日期的休息时间，包括已选择的时间段，并将其设定为可预约时间段，此操作不可撤销。",
  BLOCK_TIMES_CLEARED: "休息时间已清除",
  SAVING: "保存中",
  BLOCK_THIS_TIMESLOT: "禁用这个时间段",
  ACTIVE_THIS_TIMESLOT: "激活这个时间段",
  UNSAVED_CHANGES: "您有未保存的更改",
  YOU_HAVE_UNSAVED_CHANGES_CONTINUE:
    "您有未保存的更改。您确定要切换诊所并忽略它们吗？",
  DISCARD_AND_SWITCH: "忽略并切换",
  YOU_HAVE_NO_CONFIGURE_YOUR_WORKING_TIME_IN_THIS_CLINIC:
    "您尚未在此诊所配置工作时间",
  CONFIGURE_WORKING_TIME: "配置工作时间",
  MY_WORKING_CLINICS: "我的工作诊所",
  ALL: "全部",
  FILTER: "筛选",
  STATUS: "状态",
  SELECT_HOUR: "选择小时",
  SELECT_MINUTE: "选择分钟",
  SELECT_APPOINTMENT_TIME: "选择预约时间",
};

const clinicManagement = {
  CLINIC_MANAGEMENT: "诊所管理",
  SEARCH_CLINIC_IN_SEARCH_BAR_TO_JOIN_IN_OR_CREATE_NEW_CLINIC:
    "在搜索栏中搜索诊所以加入或创建新诊所",
  NO_CLOSED_CLINICS: "无已关闭的诊所",
  NO_PENDING_CLINICS: "无待处理的诊所",
  SEARCH_CLINIC: "搜索诊所",
  ADD_CLINIC: "添加诊所",
  CLINIC_INFO: "诊所信息",
  OWNER: "所有者",
  INVITE_PRACTITIONERS: "邀请医师",
  INVITED: "已邀请",
  NO_PRACTITIONER_FOUND: "未找到医师",
  SUBMIT_CLINIC_INFO: "提交诊所信息",
  UPDATE_CLINIC_INFO: "更新诊所信息",
  RESUBMIT_CLINIC_INFO: "重新提交诊所信息",
  ADDRESS: "地址",
  OPEN: "开启",
  PENDING: "待处理",
  MY_CLINIC: "我的诊所",
  EDIT_INFO: "编辑信息",
  ACTIVE: "活跃",
  INACTIVE: "不活跃",
  ASSOCIATED_PRACTITIONERS: "关联医师",
  NO_PHONE_NUMBER: "无电话号码",
  PRACTITIONER_INFO: "医师信息",
  SERVICES: "服务",
  WORK_TIME: "工作时间",
  WORKING_DAY: "工作日",
  NOT_AVAILABLE: "不可用",
  MINS: " 分钟",
  X_PRACTITIONERS_ARE_NOW_ACTIVE: "{{X}} 位医师已激活",
  NO_ACTIVE_PRACTITIONERS: "无活跃的医师",
  NO_INACTIVE_PRACTITIONERS: "无未激活的医师",
  INVITE: "邀请",
  WORKING_IN_CLINIC: "在诊所工作",
  QUIT_PRACTITIONER: "退出医师",
  QUIT_FROM_CLINIC: "退出诊所",
  QUIT_CLINIC_CONFIRM: "确认退出诊所",
  QUIT_CLINIC_REQUEST_SENT: "退出诊所请求已发送",
  ARE_YOU_SURE_TO_QUIT_CLINIC: "确定要退出该诊所吗",
  YOU_WILL_NOT_BE_ABLE_TO_BE_BOOKED_BY_PATIENT_FOR_THIS_CLINIC_ANYMORE:
    "您将无法再被患者预约该诊所",
  PENDING_APPROVE_TO_QUIT: "退出待审批",
  PENDING_APPROVE_TO_JOIN: "加入待审批",
  JOIN_CLINIC: "加入诊所",
  X_NEW_MEMBER_REQUESTS: "{{X}} 个新成员请求",
  JOIN_CLINIC_CONFIRM: "确认加入诊所",
  ARE_YOU_SURE_TO_JOIN_CLINIC: "确定要加入该诊所吗",
  YOUR_JOIN_REQUEST_HAS_BEEN_SENT: "加入请求已发送",
  NEW_PRACITTIONERS: "新医师",
  ACCEPT_CONFRIM: "确认接受",
  ARE_YOU_SURE_TO_ACCEPT_PRACTITIONER_REQUEST: "确定要接受该医师请求吗",
  ARE_YOU_SURE_TO_REJECT_PRACTITIONER_REQUEST: "确定要拒绝该医师请求吗",
  VIEW_INFO: "查看信息",
  NO_SERVICES_AVAILABLE: "无可用服务",
  SEARCH_PRACTITIONER_BY_NAME: "按姓名搜索医师",
  X_PENDING_APPROVAL: "{{X}} 个请求待审批",
  APPROVE: "批准",
  DECLINE: "拒绝",
  ACCEPT: "接受",
  CLEAR: "清除",
  ACCEPT_CONFIRM: "确认接受",
  REJECT_CONFIRM: "确认拒绝",
  CLOSE_CLINIC: "关闭诊所",
  CONFIRM_TO_CLOSE_CLINIC: "确认关闭诊所",
  THIS_CLINIC_WILL_BE_CLOSED_AND_ALL_ASSOCIATED_PRACTITIONERS_WILL_BE_REMOVED:
    "此诊所将被关闭，所有关联的医师将被移除",
  I_UNDERSTAND_THE_CONSEQUENCES_OF_CLOSING_THIS_CLINIC:
    "我了解关闭此诊所的后果",
  ME: "我",
  ARE_YOU_SURE_TO_REMOVE_PRACTITIONER_FROM_CLINIC:
    "确定要将此医师从诊所中移除吗",
  THIS_PRACTITIONER_WILL_NOT_BE_ABLE_TO_VIEW_USE_INFO_FOR_THIS_CLINIC:
    "此医师将无法再在该诊所工作",
  INVITE_CONFIRM: "确认邀请",
  ARE_YOU_SURE_TO_INVITE_X_TO_YOUR_CLINIC: "确定要邀请 {{X}} 加入您的诊所吗",
  CONTINUE: "继续",
  PENDING_ACCEPT: "待医师接受",
  NO_CLINIC_SELECTED: "未选择诊所",
  NO_WORKING_CLINIC_FOUND: "未找到工作中的诊所",
  NEW_CLINIC_INVITATION: "新的诊所邀请",
};

const clinicHerbs = {
  HERB_MANAGEMENT: "中药管理",
  MANAGE_YOUR_CLINIC_HERBS_FORMULA: "管理当前诊所可用的中药与药方信息",
  CURRENT_CLINIC: "当前诊所",
  CONFIGURE_CLINIC_HERBS: "管理诊所中药",
  CONFIGURE_CLINIC_FORMULA: "管理诊所药方",
  CLINIC_HERB: "诊所中药",
  CLINIC_FORMULA: "诊所药方",
  SEARCH_HERB_NAME: "搜索中药名称",
  SEARCH_FORMULA_NAME: "搜索药方名称",
  ADD_HERB: "添加中药",
  ADD_FORMULA: "添加药方",
  HERB_NAME: "中药名称",
  HERB_NAME_IN_X: "中药名称（{{X}}）",
  PINYIN: "拼音",
  IS_TOXIC: "是否具有毒性",
  IS_PREMIUM: "是否为高级药材",
  USED_BY_CREATER_ONLY: "仅创建者可用",
  TOXIC: "具有毒性",
  PREMIUM: "高级药材",
  YES: "是",
  NO: "否",
  HERB_NAME_CN: "中药名称（中文）",
  FORMULA_NAME_CN: "药方名称（中文）",
  HERB_NAME_EN: "中药名称（英文）",
  FORMULA_NAME_EN: "药方名称（英文）",
  HERB_INFO: "中药信息",
  FORMULA_INFO: "药方信息",
  THIS_FORMULA_CAN_ONLY_BE_USED_EDITED_BY_YOURSELF:
    "此药方仅限创建者本人（我）使用与编辑",
  SEARCH_HERB_NAME_HERE: "在此搜索中药名称",
  SEARCH_HERB_BY_HERB_NAME: "按中药名称搜索",
  HERB_IN_THIS_FORMULA: "药方中的中药",
  NO_HERB_ADDED: "尚未添加中药",
  FORMULA_NAME: "药方名称",
  FORMULA_NAME_IN_X: "药方名称 ({{X}})",
  NUM_HERBS: "已包含的中药数量",
  ADDED: "已添加",
  FORMULA_CREATED: "药方创建成功",
  FORMULA_UPDATED: "药方更新成功",
  HERB_CREATED: "中药创建成功",
  HERB_UPDATED: "中药更新成功",
  UNDO: "撤销移除",
  PLZ_INPUT_FORMULA_NAME_CN: "请填入药方的中文名称",
  PLZ_INPUT_FORMULA_NAME_EN: "请填入药方的英文名称",
  PLZ_INPUT_PINYIN: "请填入拼音",
  PLZ_INPUT_HERB_NAME_CN: "请填入中药的中文名称",
  PLZ_INPUT_HERB_NAME_EN: "请填入中药的英文名称",
};
const packagePages = {
  INCLUDES: "包含",
  INCLUDES_ALL_LOWER_AND: "包含低级包所有内容和",
  PP_PER_YEAR: "每人/年",
  PP_PER_MONTH: "每人/月",
  PACKAGES: "订阅服务",
  EXPIRE_IN_X_DAYS: "到期时间：{{X}}天",
  FOR_NEXT_X_DAYS: "在接下来的{{X}}天",
  SELECT_CLINIC_FOR_APPLYING_PACKAGE: "请选择要申请套餐的诊所",
  NUMBER_OF_USER: "用户人数",
  SELECTED_PACKAGE: "已选套餐",
  CURRENT_USER: "现有用户",
  NEW_PACKAGE: "新套餐",
  NO_CLINIC_MEMBERS: "暂无诊所成员",
  ASSIGN_PACKAGE_TO_USER: "为用户分配套餐",
  PER_EXIST_USER: "每位现有用户",
  PER_NEW_USER: "每位新用户",
  NO_PACKAGES_FOUND: "未找到可用的套餐",
  EXTEND: "添加人数",
  UPGRADE: "升级",
  RENEW: "继续订阅",
  PP: "每人",
  SELECT_A_PACKAGE: "选择一个套餐",
  CHANGE: "更改",
  ASSIGN: "分配",
  PURCHASE_PACKAGES: "购买套餐",
  NO_PACKAGE: "无套餐",
  EXPIRE_DATE: "到期日期",
  MAX_USERS: "最大用户数",
  TIME: "时间",
  PRICE: "价格",
  PAYMENT_HISTORY: "支付历史",
  CHECK_YOUR_PAYMENT_HISTORY: "检查您的支付历史",
  THIS_PACKAGE_IS_ONLY_FOR_YOURSELF_NOT_FOR_YOUR_CLINIC_MEMBER:
    "该套餐仅限于您自己，不适用于您的诊所成员",
  PURCHASE: "购买",
  RENEW: "续订",
  UPGRADE: "升级",
  TYPE: "类型",
};
const cmasaImport = {
  IMPORT_CLINICS: "导入诊所",
  CLINICS_FOUND_IN_X: "在 {{X}} 中找到的诊所",
  NO_CLINIC_FOUND: "未找到诊所",
  CLINICS_IMPORTED_FROM_X: "从 {{X}} 导入的诊所",
  NO_CLINIC_IMPORTED: "未导入任何诊所",
  DELETE: "删除",
  CONFIRM: "确认",
  ARE_YOU_SURE_TO_DELETE_X: "你确定要删除 {{X}} 吗？",
  THIS_ACTION_CANNOT_BE_UNDONE: "此操作无法撤销",
  IMPORT_CLINIC: "导入诊所",
  UPDATE_CLINIC: "更新诊所",
  UPLOAD_AVATAR: "上传头像",
  REUPLOAD_PROFILE_IMAGE: "重新上传头像",
  CLICK_TO_UPLOAD: "点击上传",
  PLEASE_FILL_ALL_REQUIRED_FIELDS: "请填写所有必填字段",
  PLEASE_ENTER_VALID_EMAIL: "请输入有效的邮箱地址",
  PLEASE_ENTER_SAME_PASSWORD: "请再次输入相同的密码",
  SIGN_UP_SUCCESS: "注册成功",
  CLINIC_EXISTS: "该诊所已存在",
  NEXT_STEP: "下一步",
  SAME_WITH_ORG_PASSWORD: "与原密码相同",
  PROFILE_IMG: "个人头像",
  I_CHANGED_MY_MIND: "我改变主意了",
  ADDING: "添加",
  JOINING: "加入",
  OR: "或",
  SKIP: "跳过",
  JOIN: "加入",
  SAVE_CONFIRM: "保存确认",
  ARE_YOU_SURE_TO_SUBMIT_YOUR_CLINIC_INFO: "您确定要提交您的诊所信息吗？",
  FOUND_RELEVANT_CLINICS: "我们在 VAI 系统中找到了一些可能与该诊所相关的诊所。",
  JOIN_OR_SKIP_CLINIC_GUIDE:
    "您可以点击“加入”申请加入其中一个诊所。如果不确定或没有看到想加入的诊所，您可以点击“跳过”稍后处理。",
  NEED_TO_ADD_CLINIC: "您需要在我们的 VAI 系统中添加这个诊所吗？",
  ADD_CLINIC_DESCRIPTION:
    "点击“添加”继续操作。您将成为该诊所的所有者，拥有邀请或移除成员的权限。您也可以在之后将所有权转移给诊所内的其他成员。如果您不确定是否需要现在添加，可以点击“跳过”稍后处理。",
  CLINIC_RESULT_TITLE: "该诊所的处理结果",
  CLINIC_SKIPPED_MSG:
    "该诊所已被跳过。你不会加入已有诊所，也不会将其作为新诊所添加。",
  CLINIC_NOT_LISTED: "上面列表中没有我想加入的诊所。",
  I_DO_NOT_WANT_TO_USE_THE_CLINIC_INFO_ABOVE: "我不想使用上面的诊所信息",
  PREVIOUS_CLINIC: "上一个诊所",
  NEXT_CLINIC: "下一个诊所",
  ARE_YOU_SURE_TO_CHANGE_YOUR_MIND:
    "你确定要改主意吗？这会清空过程中对这个诊所的设定",
};

const camera = {
  FOR_PATIENT: "为{{name}}患者",
  UPLOAD_PHOTO_LABEL: "上传",
  TAKE_PHOTO: "拍照",
  OR_CHOOSE_FROM_ALBUM: "或从相册选择",
  CHOOSE_PHOTO: "选择图片",
  PREVIEW: "预览",
  DISCONNECTED_TITLE: "连接已断开 / 链接已失效",
  DISCONNECTED_BODY: "此拍照链接已失效、或被关闭。请重新生成新的二维码/链接。",
  CLICK_AND_UPLOAD_WITH_YOUR_PHONE: "点击并使用手机上传照片",
  CLICK_AND_RECORD_WITH_YOUR_PHONE: "点击并使用手机录制音频",
  REFRESH_QR_CODE: "刷新二维码",
  CAMERA_TOKEN_EXPIRED: "摄像头令牌已过期",
  IF_YOU_ALREADY_CONNECTED_WITH_YOUR_PHONE:
    "若已连接手机，生成新二维码时将自动跳转至对应页面。若出现问题，请使用手机重新扫描二维码。",
};
const Library = {
  MEDICAL_PUBLICATIONS: "医学书籍",
  SEARCH_MEDICAL_PUBLICATIONS: "搜索医学书籍",
  SEARCH_PUBLICATION_BY_NAME: "按名称搜索书籍",
  RECENT: "最近阅读",
  LIBRARY: "图书馆",
  NO_PUBLICATIONS_FOUND: "未找到书籍",
  NO_RECENT_PUBLICATIONS: "未找到最近的书籍",
  NO_PUBLICATIONS_IN_LIBRARY: "未找到图书馆中的书籍",
  SEARCH_FOR_THE_MEDICAL_PUBLICATIONS_IN_SEARCH_BAR_OR_VISIT_OUR_LIBRARY:
    "在搜索栏中搜索医学书籍或访问我们的图书馆",
  JUST_NOW: "刚刚",
  RECENT_X_MINUTES: "最近{{x}}分钟",
  RECENT_X_HOURS: "最近{{x}}小时",
  RECENT_X_DAYS: "最近{{x}}天",
  ADD_THIS_BOOK_TO_YOUR_FAVORITES: "将此书添加到您的收藏夹",
  CHAPTERS: "章节",
  BOOKMARK: "书签",
  ADD_BOOKMARK: "添加书签",
  FULL_SCREEN: "全屏",
  TEXT_SIZE: "文本大小",
  NEXT_PAGE: "下一页",
  PREVIOUS_PAGE: "上一页",
  FONT_SIZE: "字体大小",
  SMALL: "小",
  MEDIUM: "中",
  LARGE: "大",
  BOOKS_MANAGEMENT: "书籍管理",
  SAVE_BOOK: "我的收藏",
  READER: "阅读器",
  REGULAR: "默认",
  SEARCH_FOR_PUBLICATIONS: "按标题或作者搜索",
};
const patientAndQuickSignUp = {
  BACK: "返回",
  ONLINE_ZOOM_MEETING: "网络会议",
  CN: "中",
  EN: "英",
  OTHER_LANGUAGE_VERSION: "English Version",
  KEY_MEMBERS: "主要成员",
  INTRODUCTION: "专业描述",
  LOAD_MORE: "加载更多",
  CURRENT: "当前",
  HISTORY_EVENT: "过往活动",
  HISTORY_CPD: "过往CPD",
  EXPIRED: "已过期",
  MONTH_FORMAT: "M月",
  EDIT: "编辑",
  FROM: "从",
  TO: "至",
  TOTAL_X: "总计{{X}}条记录",
  CLINIC: "诊所",
  HRS: "小时",
  VIEW: "查看",
  LOADING: "加载中",
  VIEW_ALL: "查看所有",
  SWITCH_TEMPLATE: "切换模板",
  TERMS_AND_CONDITIONS: "条款和条件",
  PRIVACY_POLICY: "隐私政策",
  DATA_PROCESSING_ADDENDUM: "数据处理附录",
  INITIATING: "系统初始化中",
  FAILED_TO_ACCESS_MICROPHONE: "访问麦克风失败",
  LISTENING: "正在聆听",
  TRANSCRIBING: "转录信息中",
  SPEECH_TO_TEXT: "语音转文字",
  STOP_RECORDING: "停止录音",
  WHO_IS_THIS_APPOINTMENT_FOR: "这个预约的对象是谁？",
  WHO_IS_THIS_VISIT_FOR: "这次来访的对象是谁？",
  MYSELF: "我自己",
  SOMEONE_ELSE: "其他人",
  ABOUT_YOU: "关于您",
  ABOUT_THE_PATIENT: "关于病人",
  NEXT: "下一步",
  PREVIOUS: "上一步",
  PRACTITIONER: "医生",
  APPROVED: "已同意",
  PENDING: "等待中",
  LOADING: "加载中",
  I_AGREE_TO_RECEIVE_SMS: "我同意接收关于此预约的短信通知。",
  I_AGREE_TO_RECEIVE_SMS_EMAIL: "我同意接收关于此预约的短信或者邮件通知。",
  I_AGREE_TO_RECEIVE_SMS_EMAIL_VISIT: "我同意接收短信通知。",
  WELCOME_TO_CLINIC_X: "欢迎来到{{X}}",
  UR_PRACTITIONER_X: "您的医师: {{X}}",
  SAME_WITH_YOU: "和您相同",
  ALL_GOOD: "一切就绪",
  VERIFY: "验证",
  NEXT: "下一步",
  REGISTER: "注册",
  PLEASE_AGREE_TO_RECEIVE_SMS: "请同意接收短信",
  I_HAVE_NO_BOOKING: "抱歉，您今天似乎没有已预约的就诊",
  DONT_WORRY_YOU_CAN_CREATE_QUICK_APPOINTMENT:
    "不用担心，您可以马上用几分钟时间快速预约我们的医生。",
  ENTER_MOBILE_PHONE_NUMBER_TO_CONTINUE: "请输入手机号以继续",
  VERIFY_CODE: "验证验证码",
  SEND: "发送短信验证码",
  PLEASE_SELECT_UR_BOOKING_INFO: "请确定您已预约的看诊信息",
  MAKE_APPOINTMENT_NOW: "立即预约",
  OLD_PHONE_CONFIRM_TITLE:
    "我们发现您可能之前使用过旧的手机号码{{X}}。如果这是您的号码，请输入完整的号码以确认您同意将其替换为您的当前手机号码。",
  CONFIRM_REPLACE_PHONE_CHECKBOX:
    "我确认使用当前手机号替换旧手机号（{{X}}），并更新所有相关诊所的留存信息。",
  SOMETHING_WENT_WRONG: "出错了",
  PLEASE_TRY_AGAIN_LATER: "二维码失效，请联系诊所或者稍后再试。",
  CERATE_A_BOOKING: "创建预约",
  NO_SERVICES_AVAILABLE: "暂无可用服务",
  PLEASE_SELECT_AT_LEAST_ONE_SERVICE: "请至少选择一个服务",
  YOUR_APPOINTMENT_HAS_BEEN_CHECK_IN: "您已签到，正在候诊中。",
  BOOKING_ATTENDED: "已到诊，候诊中",
  CHECK_INFO_TITLE: "请核实以下信息是否正确",
  SMS_VERIFIED: "短信已验证",
  SMS_SENT: "短信已发送",
  SELECT_TIME_SLOT: "请选择时间段",
  SELECT_SERVICES: "请选择服务",
  REMEDIAL_MASSAGE: "理疗按摩",
  NO_AVAILABLE_WORKING_TIME:
    "当前暂无可预约时段。该医生今天可能已约满，或当前时间不在其可预约范围内",
  I_AM_CMASA_MEMBER: "我是CMASA会员",
  I_AM_NOT_CMASA_MEMBER: "我不是CMASA会员",
  CMASA_MEMBER_ID: "CMASA会员ID",
  PREVIOUS_STEP: "上一步",
  ADD_CLINIC: "添加诊所",
  OWNER: "所有者",
  ME: "我",
  ADD_PACKAGE: "添加套餐",
  AND_PAY: "并支付",
  PAY_FOR_PACKAGES: "支付套餐",
  USER_EXIST: "用户已存在，请前往首页登录",
  PRACTITIONER_ACCOUNT_CREATED: "医师 {{X}} 的账号已注册成功",
  PLS_VISIT_PRACTITIONER_PORTAL_TO_USE_THE_SYSTEM:
    "请在电脑端打开医师端网页，并使用您的用户名登录后开始使用。",
  EXTRA_3_MONTHS_ON_SITE_PURCHASE: "现场购买获赠免费3个月",
  USERNAME_IS_NOT_AVAILABLE: "用户名不可用",
  MEMBER_NOT_FOUND: "无法找到会员信息，请检查手机号码与ID。",
  SUBSCRIBE_PACKAGE_FOR_CLINIC: "为诊所订阅套餐以享受更完整更便利的服务",
  RETRIEVE_INFO_FROM_CMASA: "我们将从CMASA获取您的信息，协助您的注册。",
  FOUND_CLINICS_IN_CMASA:
    "我们在CMASA中找到了与您相关的诊所，您可以先选择一个添加入我们系统（其他诊所可以稍后再添加）。",
  NO_PACKAGE_SUBSCRIBED: "尚未订阅任何套餐",
  SUBSCRIBE: "订阅",
  CURRENT_PACKAGE: "当前套餐",
  NO_PACKAGE_SUBSCRIBED: "尚未订阅任何套餐",
  SUBSCRIBE: "订阅",
  CURRENT_PACKAGE: "当前套餐",
  PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: "请填写所有必填字段",
  FINISH_CHECK_IN: "完成登记",
  U_CAN_CLOSE_THIS_PAGE_AT_ANY_TIME: "您可以随时离开此页面",
  PLS_REFER_TO_THE_APPOINTMENT_DETAIL_BELOW: "以下是您的预约详情，请查阅",
  SIGN_IN_NOW: "立即登录",
};

const homePage = {
  PRACTITIONERS: "医师",
  PATIENTS: "患者",
  SUPPLIERS: "供应商",
  OUR_FEATURES: "我们的优势",
  PARTNERS: "合作伙伴",
  PARTNER_AND_TESTIMONY: "合作伙伴与反馈",
  FAQS: "常见问题",
  THE_ALL_IN_ONE_PLATFORM_FOR_MODERN_TCM_PRACTICES: "澳大利亚医疗机构的一站式管理平台",
  SMARTER_CLINICS_BETTER_HEALING: "更好的医治",
  MENU: "菜单",
  TERMS_AND_SERVICES: "服务条款",
  BOOK_DEMO: "预约演示",
  DEMO_DESCRIPTION:
    "通过一次在线演示，深入了解我们的系统如何与您的业务流程无缝衔接。我们的团队将为您定制讲解内容，并现场回答所有问题。",
  GO_BOOK_DEMO: "🚀 立即预约演示",
  ARE_U_INTERESTED: "对我们的系统感兴趣，却还不确定它是否适合您？",
};

const ourFeaturesPage = {
  CUSTOMISED: "自定义",
  CUSTOMISED_PRACTITIONER_WEBSITE: "自定义医师网站",
  BUILD_A_PROFESSIONAL_ONLINE_PRESENCE: "构建专业的在线介绍",
  STREAMLINE_APPOINTMENT_SCHEDULING:
    "借助直观易用的在线预约系统，让就诊安排更高效。患者可自由选择合适时段、即时确认预约并自动接收提醒，有效降低爽约率，减轻诊所的行政管理压力。",

  CLINIC: "诊所",
  CLINIC_COLLABORATION: "诊所协作",
  CREATE_AND_MANAGE_MULTI_PRACTITIONER_CLINICS:
    "轻松搭建多医师诊所，邀请同仁协作，共享诊疗资源。",
  BUILD_AND_MANAGE_MULTI_PRACTITIONER_CLINICS:
    "轻松管理多医生诊所。一键邀请团队成员加入、分配权限，并安全共享患者预约与电子病历。让团队协作更顺畅，数据安全更有保障。",

  ONE_CLICK: "一键",
  ONE_CLICK_ONLINE_BOOKING: "一键在线预约",
  PATIENTS_CAN_BOOK_APPOINTMENTS_DIRECTLY_REDUCING_ADMIN_WORK:
    "患者可自主预约挂号，减轻诊所前台与行政负担。",
  STREAMLINE_APPOINTMENT_SCHEDULING:
    "通过智能在线预约系统，让患者轻松预约、即时确认并及时接收就诊提醒。有效减少爽约情况，帮助诊所显著降低管理负担。",

  AI: "AI",
  AI_ASSISTANT: "AI助手",
  GET_INSTANT_CLINICAL_REFERENCES_AND_OPERATIONAL_SUPPORT_POWERED_BY_AI:
    "借助 AI 技术，即时获取临床参考与诊所运营支持，让诊疗决策更高效，管理更智能。",
  AI_ASSISTANT_DESCRIPTION:
    "借助 AI 技术，即时获取临床参考与诊所运营支持，让诊疗决策更高效，管理更智能。",

  PRESCRIPTIONS: "药方",
  CONSULTATION_AND_PRESCRIPTIONS: "诊疗与药方",
  RECORD_PATIENT_CONDITIONS_AND_ISSUE_PRESCRIPTIONS_FOR_ACUPUNCTURE_MASSAGE_HERBAL_MEDICINE_AND_MORE:
    "一站式记录病情与开方，支持针灸、推拿、草药等多种治疗方案。",
  CONSULTATION_AND_PRESCRIPTIONS_DESCRIPTION:
    "支持线上线下诊疗一体化。医师可在系统中完整记录病症、辨证评估与疗效反馈，并快速生成针灸、推拿、草药及综合疗法处方，配合收费与配药系统高效执行。",

  EMR: "电子病历",
  ELECTRONIC_MEDICAL_RECORDS_EMR: "电子病历",
  SECURE_AND_COMPLETE_DIGITAL_RECORDS_FOR_DIAGNOSES_TREATMENTS_AND_FOLLOW_UPS:
    "构建安全完善的电子病历，全面记录诊断、治疗及复诊信息。",
  MAINTAIN_ACCURATE_SECURE_AND_COMPREHENSIVE_DIGITAL_MEDICAL_RECORDS_DOCUMENT_PATIENT_HISTORY_DIAGNOSES_TREATMENT_NOTES_AND_FOLLOW_UP_PLANS_IN_ONE_PLACE_EASILY_RETRIEVE_PAST_RECORDS_TO_SUPPORT_BETTER_CLINICAL_DECISIONS_AND_CONTINUITY_OF_CARE:
    "构建完整、安全的电子病历。系统化记录患者病情、诊断、治疗与复诊计划，方便随时查阅，助力精准辨证与持续跟进。",

  MARKETPLACE: "药市",
  HERBAL_MEDICINE_MARKETPLACE: "药市",
  ORDER_HIGH_QUALITY_HERBS_AND_EQUIPMENT_DIRECTLY_FROM_VERIFIED_SUPPLIERS:
    "直接向认证供应商采购优质草药与诊所设备，确保品质与供应稳定。",
  ACCESS_A_CURATED_MARKETPLACE_OF_CERTIFIED_HERBAL_SUPPLIERS_AND_EQUIPMENT_PROVIDERS_BROWSE_PRODUCTS_COMPARE_QUALITY_AND_PLACE_ORDERS_SEAMLESSLY_ENSURE_RELIABLE_SOURCING_OF_HERBS_PATENT_MEDICINES_AND_CLINIC_ESSENTIALS_ALL_IN_ONE_PLATFORM:
    "连接经过认证的中药与医疗设备供应商。浏览、比价、下单一站式完成，确保草药、成药及诊所物资的稳定与可靠供应。",

  AUTO_GENERATE: "自动生成",
  AUTO_GENERATE_BILLING_AND_REPORTS: "自动生成账单与报表",
  AUTO_GENERATE_INVOICES_AND_FINANCIAL_REPORTS_FOR_EASY_RECONCILIATION:
    "自动生成发票与财务报表，轻松掌握诊所收支状况，实现高效对账。",
  GENERATE_PROFESSIONAL_INVOICES_INSTANTLY_AND_KEEP_TRACK_OF_PAYMENTS_WITH_EASE_AUTOMATED_FINANCIAL_REPORTING_PROVIDES_INSIGHTS_INTO_REVENUE_EXPENSES_AND_OVERALL_CLINIC_PERFORMANCE_HELPING_YOU_MAKE_INFORMED_BUSINESS_DECISIONS:
    "即时开具发票并追踪付款记录，自动生成财务报表，清晰掌握诊所的收入、支出与整体经营情况，助你精准决策。",

  MANAGEMENT: "管理",
  INVENTORY_MANAGEMENT: "库存管理",
  TRACK_STOCK_LEVELS_IN_REAL_TIME_TO_PREVENT_SHORTAGES_OR_WASTE:
    "实时掌握诊所物资库存状况，防止断货与积压浪费。",
  MONITOR_AND_CONTROL_YOUR_CLINICS_STOCK_IN_REAL_TIME_GET_ALERTS_FOR_LOW_INVENTORY_TRACK_USAGE_AND_MANAGE_REORDERS_AUTOMATICALLY_PREVENT_SHORTAGES_OF_ESSENTIAL_HERBS_OR_OVERSTOCKING_ENSURING_SMOOTH_CLINIC_OPERATIONS:
    "实时掌握诊所物资库存，自动提醒补货并追踪消耗，避免短缺或积压，保障诊疗流程顺利进行。",

  LIBRARY: "图书馆",
  TCM_KNOWLEDGE_LIBRARY: "临床知识库",
  ACCESS_A_COMPREHENSIVE_COLLECTION_OF_CLASSICAL_TEXTS_MODERN_RESEARCH_AND_CASE_STUDIES:
    "探索汇集临床参考资料、现代研究及案例的知识库。",
  EXPLORE_A_VAST_DIGITAL_LIBRARY_FEATUREING_CLASSICAL_TCM_TEXTS_MODERN_RESEARCH_ARTICLES_AND_PRACTICAL_CASE_STUDIES_USE_IT_AS_A_TRUSTED_REFERENCE_FOR_CLINICAL_DECISION_MAKING_ONGOING_LEARNING_AND_PROFESSIONAL_DEVELOPMENT:
    "查阅全面的数字资料库，汇集临床参考资料、现代研究及实用案例——包括中医专业资源，成为你临床诊疗与持续进修的可信参考来源。",

  FEATURE_GROUP_WEBSITE_BOOKINGS_TITLE: "网站与预约",
  FEATURE_GROUP_WEBSITE_BOOKINGS_DESCRIPTION: "为患者打造专业的诊所形象，并提供简单便捷的预约方式。",

  FEATURE_GROUP_CLINICAL_CARE_TITLE: "临床诊疗",
  FEATURE_GROUP_CLINICAL_CARE_DESCRIPTION: "在一套连贯的临床工作流程中记录问诊、处方与患者病历。",

  FEATURE_GROUP_PRACTICE_OPERATIONS_TITLE: "诊所运营",
  FEATURE_GROUP_PRACTICE_OPERATIONS_DESCRIPTION: "让账单、库存与多医师诊所协作在幕后顺畅运转。",

  FEATURE_GROUP_SMART_TOOLS_TITLE: "智能工具",
  FEATURE_GROUP_SMART_TOOLS_DESCRIPTION: "将 AI 支持融入日常临床与行政工作。",
};

const partnerPage = {
  PARTNER: "合作伙伴",
  HEAR_DIRECTLY_FROM_PRACTITIONERS_AND_SUPPLIERS:
    "倾听真实声音——了解各类医疗从业者与供应商如何借助平台优化工作流程，提升诊疗与供给效率。",
  COMPREHENSIVE_FEATURES_FOR_ALL_YOU_NEED_TO: "一站式功能，为您提供所需的一切",
  POWER_YOUR_PRACTICE: "赋能澳洲医疗机构，提升诊所运营效率",
};

const testimonyPage = {
  TESTIMONY: "用户体验",
  TCM_PRACTITIONER: "物理治疗师",
  BEFORE_ADOPTING_THIS_PLATFORM:
    "过去我一直使用纸质病历和手写笔记，时间久了不仅容易混乱，还常常在复诊时浪费时间查找。现在通过这个系统，病历资料被安全地数字化管理，我随时都能查看，以往病例也能一键调出。它让我诊疗更高效，患者也更信任诊所的数据管理。这个改变大幅减轻了我的行政负担，让我能专注于真正重要的事——为患者诊治。",

  MASSAGE_THERAPIST: "按摩治疗师",
  AS_AN_INDEPENDENT_PRACTITIONER:
    "作为独立执业的按摩治疗师，以前我每天都要花大量时间接听电话、安排预约、手动记录患者信息，常常忙得无法专心看诊。现在，通过平台的个人网站功能，我能在几分钟内建立一个专业页面，患者可以直接了解我的诊疗信息、查看空档并在线预约。电话大大减少，诊所形象也更加专业现代。这就像多了一位全天候的智能助理，让我能更专注于病人，而不是繁杂的事务。",

  TCM_ACUPUNCTURIST: "足病治疗师",
  AS_A_SUPPLIER:
    "作为独立执业的足病治疗师，我需要一个能够跟上繁忙预约安排、同时不增加行政负担的系统。自从使用这个平台以来，患者档案、治疗记录与复诊安排都集中在同一个地方，让我在接诊之间无需再翻找纸质资料。在线预约功能也让患者能更方便地找到合适的时间。它让我把更多时间留给患者，而不是文书工作。",
};

const faqPage = {
  SOME_FREQUENTLY_ASKED_QUESTIONS: "一些常见的问题解答",
  IS_THIS_PLATFORM_RIGHT_FOR_ME: "这个平台适合我们吗？",
  ABSOLUTELY_U_CAN_SET_UP:
    "是的，您可以自己搭建一个网站，并在几分钟内建立一个专业页面，实现患者的病历管理。",
  IS_PATIENT_DATA_SECURE: "患者数据安全吗？",
  YES_MEDICAL_GRADE_ENCRYPTION_AND_STRICT_ACCESS_CONTROLS:
    "我们采用医疗级加密技术与严格的访问控制。所有记录均符合医疗数据保护标准，确保信息安全与隐私合规",
  DOES_THE_PLATFORM_SUPPORT_MULTI_PRACTITIONER_CLINICS: "诊所支持多医师吗？",
  YES_U_CAN_CREATE_A_TEAM_CLINIC:
    "是的，平台支持团队诊所模式。您可以邀请医师同仁共同管理预约与电子病历，安全共享信息，在保护患者隐私的同时，提升团队协作效率。",
  HOW_IS_THE_SERVICE_PRICED: "服务费用是多少？",
  YOU_CAN_CHOOSE_A_SUBSCRIPTION_PLAN_THAT_SUITS_YOUR_NEEDS:
    "选择最适合您的订阅计划，灵活满足不同诊所规模与需求。",
};

const aboutUsPage = {
  OUR_MISSION_IS_SIMPLE:
    "我们的初心很简单：让各类医疗从业者回归诊疗本质，专注于患者照护。以创新、安全与社区共建为驱动力，我们致力于支持澳大利亚现代医疗机构的成长与发展。",
  AT_OUR_CORE:
    "我们坚信，每一位医疗从业者都应拥有现代化、专业化的数字工具，让日常诊所管理更加简单高效。我们打造了这一平台，帮助独立医师、诊所与供应商获得在不断发展的医疗环境中蓬勃发展所需的工具。",
  WE_PROVIDE_AN_ALL_IN_ONE_SOLUTION_DESIGNED_SPECIFICALLY_FOR_THE_TCM_COMMUNITY:
    "我们为澳大利亚的医疗机构打造了一体化诊所管理方案——涵盖医师网站、患者档案、远程问诊、数字知情同意、账单与财务报表等功能，并支持包括传统中医、针灸与推拿理疗等多种诊疗方向。通过将医师、患者与供应商连接在同一平台上，我们让诊所运营更加高效、患者体验更加顺畅、供应链更加可靠。我们也很高兴与 HICAPS 等机构合作，共同支持澳大利亚医疗行业的发展。",
};

const bookingPage = {
  BOOK_DOCTOR: "预约医生",
  BOOKING_A_DOCTOR: "预约医生",
  SEARCH_BY_PRACTITIONER_NAME_SERVICE_TYPE_OR_SUBURB:
    "按医师姓名、治疗类型或诊所区域邮编快速查找。",
  BY: "按",
  SERVICE_TYPE: "服务类型",
  SEARCH_BY_PRACTITIONER_NAME: "按医师姓名搜索",
  SEARCHING_PRACTITIONERS: "正在搜索医师",
  NO_SERVICE_LISTED: "暂无可用服务",
  BOOK: "预约",
  WEBSITE: "网站",
  PUBLISH_WEBSITE: "发布网站",
  JOIN: "加入",
  AND_X_PRACTITIONERS_MORE: "以及其他{{X}}位医师…",
  MEDICINE_TREATMENT: "中医药方治疗",
  ACUPUNCTURE_TREATMENT: "针灸治疗",
  MASSAGE_TREATMENT: "按摩治疗",
  REMEDIAL_MASSAGE_TREATMENT: "理疗按摩治疗",
  NO_RELEVANT_PRACTITIONERS_FOUND: "未找到相关医师",
  NO_SERVICES_LISTED: "暂无可用服务",
  MORE_SERVICES: "个其他服务",
  BOOK_THIS_PRACTITIONER: "预约这位医师",
  THIS_PRACTITIONER_HAS_NOT_REGISTERED_YET: "这位医师还尚未注册",
  PUBLISH_PRACTITIONER_PROFILE_WEBSITE: "发布医师个人网站",
  VIEW_PRACTITIONER_PROFILE_WEBSITE: "查看医师个人网站",
  NO_WORKING_CLINIC: "无工作诊所",
  AND_X_MORE_CLINIC: "以及其他{{X}}个诊所",
  CHOOSE_CLINIC: "选择诊所",
  CHOOSE_CLINIC_DESCRIPTION: "选择您要预约的诊所",
  CHOOSE_SERVICE: "选择服务",
  CHOOSE_SERVICE_DESCRIPTION: "选择您要预约的服务",
  CHOOSE_SERVICE_DESCRIPTION_VISIT: "选择您这次来访需要预定的服务",
  PICK_APPOINTMENT_DATE: "选择预约日期",
  PICK_APPOINTMENT_DATE_DESCRIPTION: "选择您要预约的日期",
  MORNING: "早上",
  AFTERNOON: "下午",
  PATIENT_INFO_DESCRIPTION: "请填写患者信息",
  CONFIRM_DESCRIPTION: "请确认预约信息",
  SUBMIT_APPOINTMENT: "提交预约",
  PREV: "上一步",
  YOUR_APPOINTMENT_BOOKED_SUCCESSFULLY: "您已成功预约",
  CREATE_BOOKING: "正在预约中",
  TOMORROW: "明天",
  TODAY: "今天",
  IS_ALREADY_BOOKED: "已被他人预约",
  TIME_ALREADY_BOOKED: "该时间已被他人预约",
  YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
    "您的预订将被创建并添加到等候名单中，需要等待医师确认。一旦获得批准，您将收到更新信息。",
  ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME: "您依然确定选择预约这个时间吗?",
  BACK_TO_HOME: "关闭页面",
  INVALID_DOB: "无效的出生日期",
  NOT_AVAILABLE_FOR_BOOKING: "暂时不可预约",
  BOOKED_ENABLED_ONLY: "仅显示可预约",
  PICK_APPOINTMENT_PRACTITIONER: "为",
  PICK_APPOINTMENT_PRACTITIONER_END: "选择预约医师",
  PICK_APPOINTMENT_PRACTITIONER_SINGLE_PATIENT: "选择预约医师",
  RESELECT_APPOINTMENT_DATE: "重新选择预约日期",
  RESELECT_PRACTITIONER: "重新选择医师",
  AVAILABLE_PRACTITIONERS: "可预约医师",
  DESELECT_CHINESE_MEDICINE_FIRST: "请先取消选择中医服务。",
  DESELECT_PRODUCTS_FIRST: "请先取消已选服务产品。",
  NUMBER_OF_PEOPLE: "人数",
  PERSON: "人",
  PEOPLE: "人",
  ENTER_PATIENT_INFORMATION: "填写患者信息",
  IS_THIS_PERSON_NEW_PATIENT: "第一次来这家诊所吗？",
  EXISTING_PATIENT: "现有患者",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "注：当预约时间临近时，系统将向您发送提醒短信。",
  NO_AVAILABLE_PRACTITIONERS: "当天未找到可预约医师",
  ORR: "或者",
  CONFIRM_APPOINTMENT_DESCRIPTION: "请在确认预约前检查预约详情。",
  PICK_APPOINTMENT_TIME: "选择预约时间",
  PRODUCTS: "服务产品",
  I_AM_A_NEW_PATIENT: "我是新患者",
  SEARCH_EXISTING_PATIENT: "搜索现有患者",
  DESELECT_ALL: "清除选择",
  SERVICES_ITEM: "服务项目",
  NEW_TO_THIS_CLINIC: "这是我第一次到访这家诊所",
  A_REMINDER_EMAIL_WILL_BE_SENT_TO_THE_PATIENT:
    "预约提醒邮件将发送至患者的邮箱，请查收。",
  ADDITIONAL_INFO: "其他信息",
};

const patientConsent = {
  PATIENT_CONSENT: "患者同意書",
  CONSENT_TITLE_1: "治療內容",
  CONSENT_DESCRIPTION_1: "本人明白，在{{X}}接受治療可能包括：",
  CONSENT_ITEM_1: "使用無菌一次性針具之針灸治療",
  CONSENT_ITEM_2: "艾灸、拔罐或刮痧",
  CONSENT_ITEM_3: "中藥治療（湯劑、散劑、丸劑或顆粒劑）",
  CONSENT_ITEM_4: "根據中醫理論提供的生活方式與飲食建議",
  CONSENT_TITLE_2: "風險與副作用",
  CONSENT_DESCRIPTION_2:
    "本人明白，儘管診所會採取一切合理的防護措施，仍可能出現以下輕微副作用：",
  CONSENT_ITEM_5: "針刺部位輕微瘀青、出血或酸痛",
  CONSENT_ITEM_6: "針灸後短暫頭暈或疲倦",
  CONSENT_ITEM_7: "服用中藥後出現輕微腸胃變化或過敏反應",
  CONSENT_ITEM_8: "拔罐或刮痧後皮膚短暫出現紅痕或瘀印",
  CONSENT_ITEM_9: "嚴重不良反應極為罕見。",
  CONSENT_TITLE_3: "信息安全",
  CONSENT_DESCRIPTION_3: "本人已告知主治醫師：",
  CONSENT_ITEM_10: "現有之疾病或過敏史",
  CONSENT_ITEM_11: "懷孕情況（如適用）",
  CONSENT_ITEM_12: "目前正在服用的藥物或營養補充品",
  CONSENT_DESCRIPTION_4: "本人明白中醫治療並非急症醫療之替代方式。",
  CONSENT_DESCRIPTION_5: "本人之個人及健康資料將依據澳洲隱私法保密處理。",
  CONSENT_TITLE_4: "同意與確認",
  CONSENT_ITEM_13:
    "本人已閱讀並明白上述內容，並已有機會提出問題，所有疑問均已獲得滿意答覆。",
  CONSENT_ITEM_14: "本人自願同意接受{{X}}的醫師提供之中醫及／或針灸治療。",

  DRAW_YOUR_SIGNATURE: "签署你的签名",
  I_AGREE_AND_SIGN: "我同意并签署",
  SIGNATURE_UPLOADED: "签名已上传",
  CONSENT_SIGN_SUCCESS: "您已经成功签署治疗同意书，请继续您的看诊流程",
};

export default {
  translation: {
    ...signUp,
    ...navigation,
    ...prescription,
    ...search,
    ...info,
    ...notification,
    ...appointment,
    ...clinicManagement,
    ...clinicHerbs,
    ...Library,
    ...camera,
    ...packagePages,
    ...cmasaImport,
    ...patientAndQuickSignUp,

    ...homePage,
    ...ourFeaturesPage,
    ...partnerPage,
    ...testimonyPage,
    ...faqPage,
    ...aboutUsPage,
    ...bookingPage,
    ...patientConsent,
    BACK: "返回",
    ONLINE_ZOOM_MEETING: "网络会议",
    CN: "中",
    EN: "英",
    OTHER_LANGUAGE_VERSION: "English Version",
    KEY_MEMBERS: "主要成员",
    INTRODUCTION: "专业描述",
    LOAD_MORE: "加载更多",
    CURRENT: "当前",
    HISTORY_EVENT: "过往活动",
    HISTORY_CPD: "过往CPD",
    EXPIRED: "已过期",
    MONTH_FORMAT: "M月",
    EDIT: "编辑",
    FROM: "从",
    TO: "至",
    TOTAL_X: "总计{{X}}条记录",
    CLINIC: "诊所",
    HRS: "小时",
    VIEW: "查看",
    LOADING: "加载中",
    VIEW_ALL: "查看所有",
    SWITCH_TEMPLATE: "切换模板",
    TERMS_AND_CONDITIONS: "条款和条件",
    PRIVACY_POLICY: "隐私政策",
    INITIATING: "系统初始化中",
    FAILED_TO_ACCESS_MICROPHONE: "访问麦克风失败",
    LISTENING: "正在聆听",
    TRANSCRIBING: "转录信息中",
    SPEECH_TO_TEXT: "语音转文字",
    STOP_RECORDING: "停止录音",
    DISPLAYED: "已展示",
    RECORDS: "条数据",
    X_RECORDS: "{{X}}条数据",
    WITH_TOTAL_X_RECORDS: "总计{{X}}条数据",
    ALL_X_RECORDS_LOADED: "已加载{{X}}条数据",
    AI_AUTO_TRANSLATE: "AI补全",
    ADD_TO_CLINIC_FORMULA: "添加到诊所药方",
    NON_PREMIUM: "非高级药材",
    NON_TOXIC: "无毒性",
    APPOINTMENT_HISTORY: "预约记录",
    ADJUST_APPOINTMENT_TIME: "调整预约时间",
    ADJUST_NOW: "立即调整",
    I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_PROCEED: "我理解该操作并同意继续",
    PLEASE_NOTE_CHANGING_APPOINTMENT_DURATION_MIGHT_CAUSE_OVERBOOKING_TO_OTHER_EXISTING_APPOINTMENT:
      "请注意，更改预约时长可能会导致其他已存在的预约被超预约",
    NEXT_WEEK: "下周",
    JUMP_TO_TODAY: "跳转到今天",
    APPOINTMENTS_PENDING_FOR_SCHEDULE: "待更改的预约",
    RELOAD: "重新加载",
    CANNOT_RESCHEDULE_WITHIN_24_HOURS: "不能在24小时内重新调整预约",
    PREV_WEEK: "上一周",
    PENDING_APPROVAL: "待批准",
    SUBSCRIBE: "订阅",
    THIS_ITEM_WILL_NOT_LONGER_BE_ABLE_TO_BE_USED_IN_THIS_CLINIC:
      "该项目将不再能够在此诊所中使用",
    PLEASE_SELECT_A_VIDEO: "请选择一个视频",
    PLEASE_SELECT_A_COVER_IMAGE: "请选择一张封面图片",
    RESCHEDULE: "重新安排",
    RESCHEDULE_APPOINTMENT: "重新安排预约",
    CURRENT_APPOINTMENT_TIME: "当前预约时间",
    NEW_APPOINTMENT_TIME: "新的预约时间",
    NOT_SELECTED: "未选择",
    LINK_APPOINTMENT_TO_PATIENT_SUCCESS: "已成功将预约关联到患者",
    LINK_APPOINTMENT_TO_PATIENT: "将预约关联到患者",
    ACCEPT_APPOINTMENT: "接受预约",
    PROCEED_TO_PATIENT_INFO: "前往患者信息",
    CONFIRM_RESCHEDULE: "确认重新安排",
    APPOINTMENT_DATE: "预约日期",
    PENDING_APPOINTMENT: "待处理预约",
    PENDING_APPOINTMENTS: "待处理的预约",
    PENDING_SCHEDULE: "排程待定",
    LINK_TO_PATIENT: "关联到患者",
    LINK_TO_ANOTHER_PATIENT: "关联到另一位患者",
    LINK_ANOTHER_PATIENT_FROM_CLINIC_TO_THIS_APPOINTMENT:
      "将本诊所的另一位患者关联到此预约",
    THIS_PACKAGE_IS_ONLY_FOR_YOUR_CLINIC_PLZ_CREATE_ONE:
      "该套餐仅适用于您自己的诊所，请创建一个",
    CLEAR: "清除",
    YOUR_WORKING_CLINICS: "您所属的诊所",
    ALL: "全部",
    SEARCH_PACKAGE: "搜索套餐",
    SEARCH_TREATMENT: "搜索治疗",
    X_APPOINTMENTS_PENDING: "有 {{X}} 个预约待处理",
    X_MODALITIES_INCLUDES: "包含 {{X}} 种治疗方式",
    ARE_U_SURE_TO_ACCEPT_THIS_APPOINTMENT_SCHEDULE:
      "您确定要接受此预约安排吗？",
    OVERBOOKING_ACCEPTED: "已接受超额预约",
    RESCHEDULE_SUCCESS: "重新预约成功",
    AN_CONFIRMATION_SMS_WILL_SEND_TO_PATIENT_TO_CONFIRM_THE_RESCHEDULE:
      "将发送确认重新预约的短信给病人",
    CONTINUE: "继续",
    VIEW_THIS_DATE_SCHEDULE: "查看此日期的日程",
    PLS_NOTE_THIS_CLINIC_INFO_WILL_BE_SUBMITTED_FOR_APPROVAL:
      "请注意，诊所信息将提交审批",
    YOU_WILL_BE_NOTIFIED_WHEN_APPROVAL_IS_DONE: "审批完成后你将收到通知",
    SUBMIT_CONFIRM: "确认提交",
    PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: "请填写所有必填字段",
    CLINIC_CREATE_REQUEST_SENT: "诊所创建请求已发送",
    UPDATE_CONFIRM: "确认更新",
    ARE_YOU_SURE_TO_UPDATE_YOUR_CLINIC_INFO: "确定要更新诊所信息吗？",
    CLINIC_UPDATED: "诊所信息已更新",
    CLOSED_CLINIC_SUCCESS: "诊所关闭成功",
    PROTECTED_PAGE: "受保护的页面",
    PROTECTED_PAGE_WARNING: "你需要适当的访问权限才能查看此页面。",
    U_NEED_TO_BELONG_TO_A_CLINIC_IN_ORDER_TO_USE_THIS_SERVICE:
      "你需要隶属于某诊所才能使用此服务。",
    ACCEPT_INVITE: "接受邀请",
    ARE_YOU_SURE_TO_ACCEPT_INVITE: "确定要接受此邀请吗？",
    REJECT_INVITE: "拒绝邀请",
    ARE_YOU_SURE_TO_REJECT_INVITE: "确定要拒绝此邀请吗？",
    RESPONSE_SUCCESS: "响应成功",
    JOIN_REQUEST_SENT: "加入请求已发送",
    REQUEST_ACCEPTED: "请求已接受",
    INVITATION_SENT: "邀请已发送",
    NO_PACKAGES: "没有可用的套餐",
    X_PRACTITIONERS_ARE_NOW_INACTIVE: "有{{x}}位医生已被设为不活跃",
    ACTIVE_CONFIRM: "激活确认",
    ACTIVATE: "激活",
    INACTIVE_CONFIRM: "不活跃确认",
    ARE_YOU_SURE_TO_INACTIVE: "你确定要设为不活跃吗？",
    INACTIVE_PRACTITIONERS_ARE_NOT_ALLOWED_TO_BE_BOOKED_BY_PATIENT:
      "不活跃的医生不能被患者预约",
    REJECTED: "已拒绝",
    RESUBMIT: "重新提交",
    DELETE_APPLICATION: "删除申请",
    ARE_YOU_SURE_TO_DELETE_THIS_APPLICATION: "你确定要删除此申请吗",
    REBUILD_CLINIC: "重新提交诊所",
    DELETE_APPLICATION_SUCCESS: "申请删除成功",
    SEARCH_CLINIC_BY_NAME: "按名称搜索诊所",
    OTHER_PRACTITIONERS_ARE_NO_VISIBLE: "其他医生不可见",
    DECLINE_JOIN_INVITATION_CONFIRM: "确认拒绝加入邀请",
    ARE_YOU_SURE_TO_CANCEL_QUIT_FROM_CLINIC: "你确定要取消退出诊所吗？",
    SECTION_UNPUBLISHED: "模块未发布",
    SECTION_PUBLISHED: "模块已发布",
    REFRESH: "刷新",
    CHANGE_THIS_BOOKING_DURATION: "更改此预约时长",
    ARE_YOU_SURE_TO_CHANGE_THIS_APPOINTMENT_DURATION_FOR_X:
      "你确定要更改此预约的时长（针对 {{x}} ）吗？",
    BOOKING_DURATION_ADJUST_SUCCESS: "预约时长调整成功",
    NO_PENDING_APPOINTMENTS: "没有待定预约",
    ASSIGN_OWNERSHIP: "分配所有权",
    ARE_YOU_SURE_TO_ASSIGN_OWNERSHIP_TO: "你确定要将所有权分配给",
    YOU_WILL_BE_LOST_ALL_OWNER_PERMISSIONS_IN_THIS_CLINIC:
      "你将在此诊所失去所有拥有者权限",
    UNLOCK_WITH_VIP: "通过 VIP 解锁",
    PAY_SUCCESSFUL: "支付成功",
    OWNER_CHANGED: "所有权已改变",
    VIEW_PATIENT_INFO: "查看患者信息",
    CLINIC_QR_CODE: "诊所二维码",
    DOWNLOAD: "下载",
    WRONG_VERIFY_CODE: "验证码错误。",
    SMS_SEND_TOO_FREQUENT_WAIT_3_MIN_RETRY:
      "短信发送过于频繁，请在 1 分钟后重试。",
    CLINICS_WILL_BE_CREATED: "以下选择的诊所将会与您的账户一起创建。",
    SELECT_PRACTITIONER: "选择医师",
    PLEASE_SUBSCRIBE_PACKAGE_FOR_CLINIC: "请为该诊所订阅一个套餐。",
    CREATE_CLINICS: "创建诊所",
    UPDATE: "更新",
    SELECT_YOUR_SPECIALTY: "请选择你的专业技能",
    SELECT_PATIENT_IDENTITY_FOR_APPOINTMENT:
      "我们通过您的手机号码找到了以下患者信息，请问您是以下哪位患者？",
    SELECT_PATIENT_IDENTITY_FOR_VISIT:
      "我们通过您的手机号码找到了以下患者信息，请问您是以下哪位患者？",
    THIS_IS_ME: "这是我",
    CREATE_NEW_PATIENT: "创建新患者",
    NEW_PATIENT: "新患者",
    I_DONT_HAVE_BOOKING: "我没有预约",
    ENTER_YOUR_BOOKING_CODE_TO_CONTINUE: "请输入预约时收到的短信中的预约码",
    IF_U_DONT_HAVE_BOOKING_CODE: "如果您没有预约码，请点击下方按钮",
    DONE: "完成",
    INVALID_CODE_PLZ_CHECK_AGAIN: "输入的预约码无效",
    PRACTITIONER_NOT_AVAILABLE_FOR_BOOKING: "该医师目前无法提供预约服务",
    SELECT_SERVICE: "选择服务",
    RESET: "重置",
    UNIT_NO_SHOP_NO: "门牌号/门店号",
    STREET_NO: "街道号",
    STREET_NAME: "街道名称",
    CLINIC_NAME_IS_REQUIRED: "诊所名称是必填项",
    CLINIC_CREATED: "诊所创建成功",
    TYPE_TO_SEARCH: "输入以搜索",
    STREET_TYPE: "街道类型",
    PRESS_TO_EDIT: "点按以编辑",
    PREFER_NOT_TO_SAY: "不便透露",
    ENTER_PRESCRIPTION_SYTEM: "进入开方系统",
    LOGIN: "登录",
    NO_PRODUCTS_AVAILABLE_FOR_THIS_PRACTITIONER:
      "该医师没有设置可预约的服务产品",

    DEEP_TISSUE_MASSAGE: "深层组织按摩",
    SPORTS_MASSAGE: "运动按摩",
    DRY_NEEDLING: "干针",
    CUPPING: "拔罐",
    PREGNANCY_MASSAGE: "孕妇按摩",
    MYOTHERAPY: "肌肉疼痛治疗",
    ASSISTED_STRETCHING: "辅助拉伸",
    TRIGGER_PT_THERAPY: "刺痛点治疗",
    MYOFASCIAL_RELEASE: "筋膜松解",
    JOINT_MOBILISATION: "关节松动术",
    PHYSIO: "物理治疗",
    CHIRO: "脊椎治疗",
    BEAUTY: "美容",
    COSMETIC_MEDICINE: "医美",

    INVALID_PHONE_FORMAT_SMS_WARNING: "当前号码可能影响短信接收，请确保为04XXXXXXXX格式以保证短信收取正确。",
    DATE_CANNOT_BE_IN_FUTURE: "不能为未来日期",
    INVALID_DATE: "无效日期",
    SAVE_APPOINTMENT_INFO_LOCALLY: "保存预约信息至本地",

    FOLLOW_US_ON_FACEBOOK: "在Facebook上关注我们",
    DO_YOU_HAVE_BOOKING_CODE: "您有预约码吗？",
    BOOKING_CODE_HELP_TEXT: "如果您已经预约，请使用预约码继续；如果没有预约，我们可以帮助您完成这次来访的注册。",
    YES_I_HAVE_BOOKING_CODE: "我有预约码",
    NO_I_DONT_HAVE_BOOKING_CODE: "我没有预约码",
    ENTER_CODE_TO_CHECK_IN: "请输入您的预约码以完成签到",
    CREATE_NEW_BOOKING_INSTEAD: "完成签到",
    I_M_WALKING_CUSTOMER: "我是一名到场就诊的客人",
    OCCUPATION: "职业",
  },
};
